var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiscordPrimaryLinear3232 = function SvgIconDiscordPrimaryLinear3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-discord-primary-linear-32*32_svg__a)",
    d: "M27.13 6.027c3.615 5.23 5.4 11.13 4.732 17.922a.1.1 0 0 1-.042.072 26.6 26.6 0 0 1-8.003 3.975.1.1 0 0 1-.112-.038 21 21 0 0 1-1.634-2.615.1.1 0 0 1 .055-.14c.871-.323 1.7-.71 2.497-1.17a.1.1 0 0 0 .01-.167q-.256-.186-.498-.383a.1.1 0 0 0-.104-.013c-5.176 2.353-10.845 2.353-16.082 0a.1.1 0 0 0-.104.014c-.16.13-.328.259-.496.382a.1.1 0 0 0 .01.168c.798.45 1.626.846 2.497 1.17a.1.1 0 0 1 .055.14 18.7 18.7 0 0 1-1.634 2.615.105.105 0 0 1-.113.037 26.7 26.7 0 0 1-7.99-3.975.1.1 0 0 1-.042-.074c-.557-5.874.58-11.823 4.727-17.921a.1.1 0 0 1 .043-.036 26.6 26.6 0 0 1 6.514-1.988.1.1 0 0 1 .105.048c.282.493.605 1.124.823 1.64a24.8 24.8 0 0 1 7.316 0c.218-.505.53-1.147.811-1.64a.1.1 0 0 1 .105-.048 26.7 26.7 0 0 1 6.513 1.988.08.08 0 0 1 .042.037m-13.56 11.17c.024-1.737-1.262-3.174-2.877-3.174-1.602 0-2.876 1.425-2.876 3.174s1.3 3.173 2.876 3.173c1.602 0 2.876-1.424 2.876-3.173m10.632 0c.025-1.737-1.261-3.174-2.876-3.174-1.602 0-2.876 1.425-2.876 3.174s1.3 3.173 2.876 3.173c1.615 0 2.876-1.424 2.876-3.173"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-discord-primary-linear-32*32_svg__a",
    x1: 12.684,
    x2: 16.703,
    y1: 12.338,
    y2: 33.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })))));
};
export default SvgIconDiscordPrimaryLinear3232;